'use client';

import React, { forwardRef, useCallback, useContext } from 'react';
import { useBloodVision } from '../BloodVisionContext';
import SelectionSection from './SelectionSection';
import { ZipCodeContext } from './ZipCodeContext';
import { focusZipCodeInput } from './checkoutGuidance';
import dynamic from 'next/dynamic';

const HsaFsaOffer = dynamic(
  () => import('./HsaFsaOffer').then((mod) => mod.HsaFsaOffer),
  { ssr: false },
);

const ImageModal = dynamic(
  () =>
    import('components/ring-air/ProductSelectionSection/ImageModal').then(
      (mod) => mod.ImageModal,
    ),
  { ssr: false },
);

const HSASection = forwardRef<HTMLElement>((props, ref) => {
  const {
    isHsaFsaIncluded,
    setIsHsaFsaIncluded,
    selectedModality,
    selectionRequiredHint,
    hasUserProvidedZip,
    isZipValid,
    zipCode,
  } = useBloodVision();
  const { zipCodeInputRef } = useContext(ZipCodeContext);

  const hsaOptions = [
    { label: 'Yes', value: 'include' },
    { label: 'No', value: 'exclude' },
  ];

  const isZipLocked =
    !hasUserProvidedZip || !zipCode || zipCode.length !== 5 || !isZipValid;
  const isDisabled = !selectedModality || isZipLocked;

  const handleFocusZipInput = useCallback(() => {
    focusZipCodeInput(zipCodeInputRef);
  }, [zipCodeInputRef]);

  return (
    <SelectionSection
      ref={ref}
      title="HSA/FSA - Use your pre-tax dollars"
      subtitle={isDisabled ? '' : ''}
      options={hsaOptions}
      selectedValue={
        isHsaFsaIncluded === null
          ? ''
          : isHsaFsaIncluded
            ? 'include'
            : 'exclude'
      }
      onSelect={(value) => {
        setIsHsaFsaIncluded(value === 'include');
      }}
      disabledOptions={
        isDisabled ? hsaOptions.map((option) => option.value) : []
      }
      showInfoButton={true}
      infoModalSecond={
        <ImageModal>
          <HsaFsaOffer />
        </ImageModal>
      }
      dataButtonType="blood-vision hsa/fsa selector"
      dataProduct="Ultrahuman Blood Vision"
      showRequiredHint={selectionRequiredHint === 'hsa'}
      onDisabledOptionClick={isZipLocked ? handleFocusZipInput : undefined}
    />
  );
});

HSASection.displayName = 'HSASection';

export type HSASectionRef = React.RefObject<HTMLDivElement>;

export default HSASection;
